<div class="a00250">
    <div class="text">{{ text }}</div>
    <div class="right-divider"></div>
</div>
